export default __webpack_public_path__ + "static/media/messages.d49d2941.svg";